<template>
  <vs-popup
    class="popup"
    button-close-hidden
    v-bind="$attrs"
    v-on="$listeners"
  >
    <h3 class="vs-popup--title-on-top">
      {{ isAdd ? 'Add' : 'Edit' }} Trip Status
    </h3>
    <img
      class="vs-popup--close-button cursor-pointer"
      :src="require('@/assets/shipo-popup-icon-close.svg')"
      @click="closeModal"
      style="z-index: 2;"
    >
    <div
      id="modalContainer"
      class="w-full vs-con-loading__container grid grid-cols-1 gap-5 px-3"
    >
      <hr class="border-dashed mt-12 mb-2">
      <div class="w-full">
        <label class="block mb-2 font-semibold">Trip Status Name</label>
        <div class="relative">
          <vs-input
            class="w-full"
            type="text"
            placeholder="Trip Status Name"
            v-model="form.name"
            :color="!form.name ? 'danger' : ''"
          />
        </div>
      </div>
      <div class="w-full">
        <label class="block mb-2 font-semibold">Trip Status Code</label>
        <div class="relative">
          <vs-input
            class="w-full"
            type="text"
            placeholder="Trip Status Code"
            v-model="form.code"
            :color="!form.code ? 'danger' : ''"
            @input="form.code = form.code.replace(/\s/g, '')"
          />
        </div>
      </div>
      <div class="w-full">
        <label class="block mb-2 font-semibold">Trip Status Color</label>
        <div class="relative flex items-center gap-3 py-1">
          <input
            class="input-field w-10 h-10 p-0 border-none"
            type="color"
            v-model="form.color_code"
            @input="onColorInput"
            style="min-width: 2.5rem; min-height: 2.5rem;"
          >
          <vs-input
            class="w-40"
            type="text"
            v-model="form.color_code"
            placeholder="Hex (#FFFFFF)"
            :color="!form.color_code ? 'danger' : ''"
          />
        </div>
      </div>

      <div class="mb-6">
        <label class="text-sm block mb-1">Sample</label>
        <div
          class="w-full py-2 rounded-lg text-center font-medium"
          :style="{ backgroundColor: `${form.color_code}40` || '#ccc', color: form.color_code || '#fff' }"
        >
          TRIP STATUS
        </div>
      </div>
 
      <!-- Buttons -->
      <div class="flex justify-between">
        <vs-button
          type="border"
          color="primary"
          class="w-1/2 mr-2 button"
          @click="closeModal"
        >
          Cancel
        </vs-button>
        <vs-button
          class="w-1/2 button shadow-primary"
          color="primary"
          @click="onHandleSubmit"
        >
          {{ isAdd ? 'Add Trip Status' : 'Save Change' }}
        </vs-button>
      </div>
    </div>
  </vs-popup>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ModalTripStatus',
  props: {
    isAdd: {
      type: Boolean,
      default: () => true
    },
    tripStatusData: {
      type: Object,
      default: () => {}
    }
  },
  computed: {},
  watch: {
    tripStatusData: {
      handler(val) {
        if (!this.isAdd) {
          this.form = {
            ...val
          }
        }
      }
    },
    isLoading: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val) {
          this.$vs.loading({
            type: 'radius',
            color: 'primary',
            container: '#modalContainer',
            scale: 0.5
          })

          return
        }

        this.$vs.loading.close('#modalContainer > .con-vs-loading')
      }
    }
  },
  data() {
    return {
      form: {
        name: null,
        code: null,
        color_code: '#000000'
      },
      isLoading: false
    }
  },
  methods: {
    onColorInput(event) {
      let color;
      if (event && event.target && event.target.value) {
        color = event.target.value.toUpperCase();
      } else if (typeof event === 'string') {
        color = event;
      } else {
        color = '#000000';
      }
      if (color && !/^#[0-9A-Fa-f]{6}$/.test(color)) {
        this.form.color_code = '#000000';
      } else {
        this.form.color_code = color.toUpperCase();
      }
    },
    async onHandleSubmit() {
      try {
        this.isLoading = true
        
        const validateKey = [
          'name',
          'code',
          'color_code'
        ]

        const hasEmptyField = Object.keys(this.form)
          .find(key => validateKey.includes(key) && this.isEmpty(this.form[key]))

        if (hasEmptyField) {
          this.isLoading = false
          this.showFailedNotification(this, `Field ${hasEmptyField.replace('_', ' ')} cannot be empty`, 'Error')
          return
        }

        if (this.isAdd) {
          await this.$store.dispatch('KeyActivityStatus/postTripStatus', this.form)
          this.showSuccessNotification(this, 'Trip Status successfully added.')
        } else {
          const payload = {
            id: this.form.id,
            form: {
              name: this.form.name,
              code: this.form.code,
              color_code: this.form.color_code
            }
          }
          await this.$store.dispatch('KeyActivityStatus/putTripStatus', payload)
          this.showSuccessNotification(this, 'Trip Status successfully updated.')
        }

        this.closeModal()
      } catch ({ error }) {
        this.isLoading = false
        const message = error?.errors?.[0]?.[0]?.message || error?.message || 'Failed to save changes, please try again'

        this.showFailedNotification(this, message, 'Error')
      }
    },
    closeModal() {
      this.$emit('action')
      this.form = this.$options.data().form
      this.isLoading = false
    }
  }
}
</script>

<style lang="scss" scoped>
.popup {
  /deep/.vs-popup {
    @apply w-auto;
    @apply rounded-2xl;
    min-width: 30rem;

    &--title {
      @apply hidden;
    }

    &--content {
      @apply relative;
      @apply p-4;
      @apply m-0;
      @apply flex;
      @apply flex-col;
      @apply h-full;
      @apply w-full;
      @apply items-center;

      &-title {
        @apply text-2xl;
        @apply font-semibold;
        @apply text-grey;
        @apply mt-8;
      }
    }

    &--img {
      width: 152px;
    }

    &--close-button {
      @apply cursor-pointer;
      @apply absolute;
      width: 35px;
      top: 1rem;
      right: 1rem;
    }

    &--title-on-top {
      @apply absolute;
      width: 90%;
      top: 1.5rem;
      left: 1rem;
      font-weight: 600;
      font-size: 1.5rem;
    }

    &--ok {
      @apply rounded-xl;
      @apply border-2;
      @apply mt-20;
      @apply py-4;
      @apply min-w-button;
      @apply font-semibold;
      height: calc( 1rem * 10 / 3 );

      &.shadow-secondary {
        -webkit-box-shadow: 0 8px 25px -8px rgba(var(--vs-secondary),1);
        box-shadow: 0 8px 25px -8px rgba(var(--vs-secondary),1);
      }

      &:focus {
        @apply outline-none;
        @apply border-none;
      }
    }

    p {
      @apply text-base;
      @apply text-grey-001;
    }
  }
}
</style>
